import styled from 'styled-components';
import SVG from 'react-inlinesvg';
import { Container } from '../styled/containers';
import LinkHandler from '../link-handler';
import { buttonStyles } from '../styled/buttons';
import { breakpoint } from '../theme/breakpoint';
import { removeListStyles } from '../styled/utils';

export const StyledLinkHandler = styled(LinkHandler)`
  ${buttonStyles};

  gap: ${({ theme }) => theme.spacing.standard};
  flex: 1;
  display: flex;

  padding: ${({ theme }) => theme.spacing.standard};
  text-decoration: none;
  text-align: left;
`;

export const ListItem = styled.li`
  margin: 0;
  display: flex;
`;

export const TileText = styled.h3`
  font-size: ${({ theme }) => theme.fontsize.h4};
  margin: 0;
  padding: 0;
  flex: 1;
`;

export const StyledSVG = styled(SVG)`
  flex: none;
  margin-top: ${({ theme }) => theme.spacing.tiny};
`;

export const TileWrapper = styled.ul`
  ${removeListStyles}

  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  gap: ${({ theme }) => theme.spacing.small};

  ${breakpoint.mobileLand`
    grid-template-columns: repeat(2, minmax(0, 1fr));
  `};

  ${breakpoint.tablet`
    grid-template-columns: repeat(3, minmax(0, 1fr));
  `};

  ${breakpoint.desktop`
    grid-template-columns: ${({ $narrowContainer, $insideSideBar }) => {
      if ($insideSideBar) {
        return 'repeat(1, minmax(0, 1fr))';
      }
      if ($narrowContainer) {
        return 'repeat(3, minmax(0, 1fr))';
      }
      return 'repeat(4, minmax(0, 1fr))';
    }};
  `}
`;

export const TileGridWrapper = styled(Container)`
  margin-top: ${({ theme }) => theme.spacing.medium};
  margin-bottom: ${({ theme }) => theme.spacing.large};
  padding-left: 0;
  padding-right: 0;
`;
